<template>
  <div :class="['ep-tag-list',{'active':active}]" @click="seleted($event)">
    <slot></slot>
  </div>
</template>

<script>
  import unit from '../../../lib/unit'
  export default {
    name: 'ep-tag-list',
    data() {
      return {
        active: false,
        curcolor: 'red'
      }
    },
    props: {
      label: {
        default: '',
      }
    },
    computed: {
      value() {
        return this.$parent.value
      }
    },
    watch: {
      value() {
        this.isSeleted()
      }
    },
    created() {
      this.$on('change', (val) => {
        if (this.label != val) {
          this.active = false
        }
      })
    },
    mounted() {
      this.isSeleted()
      this.init_content()
    },
    mixins: [unit],
    methods: {
      init_content() {
        if(this.$slots.default) return

        this.$el.innerHTML = this.label
      },
      isSeleted() {
        if (this.value != '' && this.value == this.label) {
          this.active = true
        } else {
          this.active = false
        }
      },
      seleted(curTarget) {
        this.dispatch('ep-tag', 'change', this.label, curTarget)
        this.active = true
      }
    }
  }

</script>

<style scoped>
  .ep-tag-list {
    display: inline-block;
    box-sizing: border-box;
    padding: 0 5px;
    transition: all .3s ease-in-out;
    position: relative;
    width: auto;    
  }

  .ep-tag-list:after {
    content: '';
    position: absolute;
    width: 1px;
    height: 2px;
    bottom: 0;
    left: 50%;
    background: #369eff;
    opacity: 0;
    transition: all .3s ease-in-out;
  }

  .ep-tag-list:hover:after {
    width: 100%;
    left: 0;
    opacity: 1;
  }

  .active {
    color: #369eff;
  }

  .active:after {
    width: 100%;
    left: 0;
    opacity: 1;
  }
</style>


// WEBPACK FOOTER //
// tag_list.vue?2084762b